import { API_ENPOINTS } from '../../constants/api';
import {
  get,
  post
} from '../../utils/requests';

const ISN_API = API_ENPOINTS.isn;

export const postReport = (testId, layout) => {
  const endpoint = `${ISN_API}/${testId}/postReport?layout=${layout}`;
  return post(endpoint);
};



// WEBPACK FOOTER //
// src/actions/isn/apiRequests.js